module.exports = __webpack_public_path__ + "104a36d0eb126cc8e465b163d8a76c97.svg";